import { TilbyDatePipe } from "@tilby/tilby-ui-lib/pipes/tilby-date";

export class SalesDataSentFe {
    id = 0;
    name = '';
    final_amount = 0;
    closed_at = TilbyDatePipe.date({outputFormat:'date'});
    status = '';
    uuid = '';
    sale_data_sent = [
        {
            id: 0,
            uuid: '',
            status: '',
            retry: 0,
            entity: '',
            reason_failed: '',
            sale_id: '',
            created_by_id: 0,
            updated_by_id: 0,
            created_at: TilbyDatePipe.date({outputFormat:'date'}), 
            updated_at: TilbyDatePipe.date({outputFormat:'date'})
        }
    ];
}

export const filterableSalesDataSentColumnsWithSearchBar: (keyof SalesDataSentFe)[] = ["name"];

export interface MassiveSendState {
    updated_at: string;
    sale_ids: number[];
}

export interface MassiveSendPreferencesSatus {
    isLockActive: boolean;
    sale_ids: number[];
}